/* eslint-disable no-console */
import { AxiosError } from 'axios';
import { put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { Nullable } from '../../types';
// import { LOCAL_STORAGE_KEYS } from '../../constants';
import { setRedirect } from '../../../reducers/redirectSlice';

export default function* errorCodeSaga(
  action: PayloadAction<Nullable<AxiosError>>,
) {
  const error = action.payload;

  if (!error || error.response === undefined) {
    return;
  }

  // Add logging
  console.log('Error saga triggered:', {
    status: error.response.status,
    url: error.config?.url,
  });

  switch (error.response.status) {
    // case 401:
    //   // Add logging
    //   console.log('401 error triggered redirect to login');
    //   // localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    //   // yield put(resetApplicationStore());
    //   // yield put(
    //   //   setRedirect({
    //   //     destination: '/logout',
    //   //     state: {
    //   //       locationFrom: `${window.location.pathname}${window.location.search}`,
    //   //     },
    //   //   }),
    //   // );
    //   break;
    case 403:
      yield put(
        setRedirect({
          destination: '/forbidden',
        }),
      );
      break;
    default:
      // TODO : Add Geri's popup
      break;
  }
}
